import { useDispatch, useSelector } from 'react-redux';
import { NOTIFICATION_TYPE } from 'constant';
import { ACTIONS_TYPES } from 'redux/helper';

export const useNotification = ({ actions = [], isGetAll = false }) => {
  const dispatch = useDispatch();
  const store = useSelector((e) => e);

  const errors = store
    .notifications
    .filter(
      (e) => (!!actions.includes(e.action) || isGetAll) && e.type === NOTIFICATION_TYPE.ERROR,
    ) || [];

  const successes = store
    .notifications
    .filter(
      (e) => (!!actions.includes(e.action) || isGetAll) && e.type === NOTIFICATION_TYPE.SUCCESS,
    ) || [];

  const setNotification = ({ message = '', type = 'success' }) => {
    dispatch({
      type: ACTIONS_TYPES.COMMON.NOTIFICATION_SHOW,
      payload: {
        message,
        type: type === 'success' ? NOTIFICATION_TYPE.SUCCESS : NOTIFICATION_TYPE.ERROR,
      },
    });
  };

  return [errors, successes, setNotification];
};
